import { createContext, useContext, useState, useCallback } from 'react'

const TemplateCreationContext = createContext(null)

export function TemplateCreationProvider({ children }) {
    // Template Details State
    const [templateDetails, setTemplateDetails] = useState({
        name: '',
        description: '',
        type: '',
        styleGuide: '',
        referenceFile: '',
        trainingSets: [],

    })

    // Reference File State
    const [referenceFile, setReferenceFile] = useState(null)

    // Training Sets State
    const [trainingSets, setTrainingSets] = useState([])

    // Update template details
    const updateTemplateDetails = useCallback((details) => {
        setTemplateDetails(prev => ({
            ...prev,
            ...details
        }))
    }, [])

    // Update reference file
    const updateReferenceFile = useCallback((file) => {
        setTemplateDetails(prev => {
            return {
                ...prev,
                referenceFile: file
            }
        })
    }, [])

    // Add training set
    const addTrainingSet = useCallback((trainingSet) => {
        //setTrainingSets(prev => [...prev, trainingSet])
        setTemplateDetails(prev => {
            return {
                ...prev,
                trainingSets: [...prev.trainingSets, trainingSet]
            }
        })
    }, [])

    // Remove training set
    const removeTrainingSet = useCallback((trainingSetId) => {
        setTemplateDetails(prev => {
            return {
                ...prev,
                trainingSets: prev.trainingSets.filter(set => set.id !== trainingSetId)
            }
        })
    }, [])

    // Update training sets
    const updateTrainingSets = useCallback((sets) => {
        setTemplateDetails(prev => {
            return {
                ...prev,
                trainingSets: sets
            }
        })
    }, [])

    // Reset all data
    const resetTemplateCreation = useCallback(() => {
        setTemplateDetails({
            name: '',
            description: '',
            type: '',
            styleGuide: '',
            referenceFile: '',
            trainingSets: [],
        })
    }, [])

    // Get summary of all changes
    const getTemplateSummary = useCallback(() => {
        return {
            templateDetails,
            hasChanges: templateDetails.name || templateDetails.referenceFile || templateDetails.trainingSets.length > 0
        }
    }, [templateDetails])

    const value = {
        // State
        templateDetails,

        // Actions
        updateTemplateDetails,
        addTrainingSet,
        removeTrainingSet,
        resetTemplateCreation,
        getTemplateSummary,
        updateTrainingSets,
        updateReferenceFile,
    }

    return (
        <TemplateCreationContext.Provider value={value}>
            {children}
        </TemplateCreationContext.Provider>
    )
}

export function useTemplateCreation() {
    const context = useContext(TemplateCreationContext)
    if (!context) {
        throw new Error('useTemplateCreation must be used within a TemplateCreationProvider')
    }
    return context
} 